// extracted by mini-css-extract-plugin
export default {"iconContainer":"InputWithIcon_iconContainer__PUo2J","inputIcon":"InputWithIcon_inputIcon__eFqpM"};